import { useState } from 'react';
import { Badge, Button, Popover, List, Typography, Space, Empty } from 'antd';
import { BellOutlined, CheckOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useNotificationList, useUnreadCount, useMarkAllRead } from '@/hooks/useNotifications';
import { ROUTES } from '@/constants/routes';

const { Text } = Typography;

/**
 * Notification bell (EG-355 §4). Badge count + popover hiện 5 thông báo gần nhất
 * + link "Xem tất cả" → /notifications. Phase 2 sẽ wire WebSocket realtime; hiện
 * tại fall back polling 60s qua useNotifications.
 */
export const NotificationBell = () => {
  const [open, setOpen] = useState(false);
  const { data: unread } = useUnreadCount();
  const { data: list = [] } = useNotificationList();
  const markAll = useMarkAllRead();

  const recent = list.slice(0, 5);
  const count = unread?.count ?? 0;

  const content = (
    <div style={{ width: 320 }}>
      <Space style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
        <Text strong>Thông báo</Text>
        {count > 0 && (
          <Button
            type="link"
            size="small"
            icon={<CheckOutlined />}
            onClick={() => markAll.mutate()}
            loading={markAll.isPending}
          >
            Đánh dấu đã đọc
          </Button>
        )}
      </Space>
      {recent.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Chưa có thông báo" />
      ) : (
        <List
          size="small"
          dataSource={recent}
          renderItem={(n) => (
            <List.Item style={{ background: n.read ? 'transparent' : '#fff6f8', padding: 8 }}>
              <List.Item.Meta
                title={
                  <Text style={{ fontSize: 13, fontWeight: n.read ? 400 : 600 }}>
                    {n.title}
                  </Text>
                }
                description={
                  <Text type="secondary" style={{ fontSize: 11 }} ellipsis>
                    {n.body}
                  </Text>
                }
              />
            </List.Item>
          )}
        />
      )}
      <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 8, marginTop: 8, textAlign: 'center' }}>
        <Link to={ROUTES.notifications} onClick={() => setOpen(false)}>
          Xem tất cả →
        </Link>
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement="bottomRight"
    >
      <Badge count={count} size="small" offset={[-4, 4]}>
        <Button type="text" icon={<BellOutlined style={{ fontSize: 18 }} />} />
      </Badge>
    </Popover>
  );
};
